import { PriceComponent } from "./vndaComponents";

const selectionBlockColors = {
  productInformation: {},

  async setColorsSelection() {
    if (window.productsSelection && Object.keys(window.productsSelection).length > 0) {
      this.productInformation = window.productsSelection;
    } else {
      // Definir productInformation como um objeto vazio se window.productsSelection estiver vazio ou indefinido
      this.productInformation = {};
    }

    const productsWithSelection = document.querySelectorAll('[data-related-colors]');

    // Usar Promise.all para garantir que todos os elementos sejam processados
    await Promise.all(Array.from(productsWithSelection).map(async (el) => {
      await this.processElement(el, this.productInformation); // Passar this.productInformation como argumento
    }));
  },

  async fetchRelatedProductObj(colorProductId, productInformation, maxRetries = 5, delay = 200) {
    let attempts = 0;
    while (attempts < maxRetries) {
      let relatedProductObj = productInformation[colorProductId];
      if (relatedProductObj) {
        return relatedProductObj;
      }
      console.warn(`Tentativa ${attempts + 1} de encontrar relatedProductObj para colorProductId: ${colorProductId} falhou.`);
      attempts++;
      await new Promise(resolve => setTimeout(resolve, delay));
    }
    throw new Error(`relatedProductObj não encontrado para colorProductId: ${colorProductId} após ${maxRetries} tentativas.`);
  },

  async processElement(el, productInformation) {
    const currentId = el.dataset.productId;
    const currentProductObj = currentId ? productInformation[currentId] : null;
    const currentProductImageBox = el.querySelector('[data-image-box]');
    const currentProductName = el.querySelector('[data-product-block-name]');
    const currentProductPrice = el.querySelector('[data-init-price]');
    const optionsColor = el.querySelectorAll('[data-option-color]');
    const showMoreColors = el.querySelector('[data-show-more-colors]');
    const productAnchors = el.querySelectorAll('[data-product-redirect]');
    const skuInput = el.querySelector('[name="sku"]');

    if (showMoreColors) {
      showMoreColors.querySelector('[data-open-dropdown]').addEventListener('click', function() {
        showMoreColors.classList.toggle('-open');
      });
    }

    optionsColor.forEach(color => {
      color.addEventListener("click", async () => {
        optionsColor.forEach(c => {
          c == color ? c.classList.add('-active') : c.classList.remove('-active');
        });

        color.closest('.content-button-color').classList.add('active');

        optionsColor.forEach(c => {
          if (c !== color) {
            c.closest('.content-button-color').classList.remove('active');
          }
        });

        let colorProductId = color.dataset.colorProductId;
        
        // Use fetchRelatedProductObj para garantir que relatedProductObj seja encontrado
        let relatedProductObj;
        try {
          relatedProductObj = await this.fetchRelatedProductObj(colorProductId, productInformation);
        } catch (error) {
          console.error(error.message);
          return;
        }

        console.log(`Produto com ID ${currentId} relacionado:`, relatedProductObj);

        if (currentProductName && relatedProductObj) {
          currentProductName.textContent = relatedProductObj.name || "Nome não disponível";
        }

        document.querySelectorAll('[data-product-id]').forEach(el => {
          el.dataset.productId = colorProductId;
        });

        if (currentProductPrice) {
          let priceConfig = `{
            "productId": ${colorProductId},
            "showInstallmentsWithoutInterest": true,
            "showInstallmentsWithInterest": false, 
            "mode": "short",
            "htmlTag": "p"
          }`;

          if (relatedProductObj.mainVariant) {
            currentProductPrice.setAttribute('data-sku', relatedProductObj.mainVariant.sku);
          }
          if (relatedProductObj.price) {
            currentProductPrice.setAttribute("data-price", relatedProductObj.price);
          }
          if (relatedProductObj.sale_price) {
            currentProductPrice.setAttribute("data-sale-price", relatedProductObj.sale_price);
          }
          if (relatedProductObj.discount) {
            currentProductPrice.setAttribute("data-discount-percent", relatedProductObj.discount);
          }
          currentProductPrice.setAttribute("data-init-price", priceConfig);
          currentProductPrice.setAttribute("data-was-processed", "false");

          await PriceComponent.init(document.querySelectorAll('[data-product-id="' + colorProductId + '"]'));
        }

        if (productAnchors) {
          productAnchors.forEach(anchor => {
            if (relatedProductObj.productUrl) {
              anchor.setAttribute('href', relatedProductObj.productUrl);
            }
          });
        }

        if (skuInput) skuInput.value = color.dataset.colorSku;

        window.Vnda.Component.Price.update();
        
        if (relatedProductObj.images) {
          if (currentProductImageBox) {
            let imagesHTML = relatedProductObj.images
              .replaceAll('class="lazy"', '')
              .replaceAll('class="swiper-lazy"', '');
        
            // Cria um elemento div temporário para manipular o HTML das imagens
            let tempDiv = document.createElement('div');
            tempDiv.innerHTML = imagesHTML;
        
            // Seleciona todas as imagens dentro do HTML
            let images = tempDiv.querySelectorAll('img');
        
            // Itera sobre cada imagem e substitui data-srcset por srcset se existir
            images.forEach(img => {
              if (img.hasAttribute('data-srcset')) {
                img.setAttribute('srcset', img.getAttribute('data-srcset'));
                img.removeAttribute('data-srcset');
              }
            });
        
            // Atualiza o HTML das imagens no elemento destino
            currentProductImageBox.querySelector('figure').innerHTML = tempDiv.innerHTML;
          }
        }

        if (relatedProductObj.variants) {
          let sizesHTML = relatedProductObj.variants.map(variant => {
            let sizeClass = variant.stock <= 0 ? '-unavailable' : '-available';
            return `<span 
              class="size ${sizeClass}" 
              data-size="${variant.attribute1}"
              data-sku="${variant.sku}"
              data-stock="${variant.stock}"
            >${variant.attribute1}</span>`;
          }).join('\n');

          el.setAttribute('data-sizes', sizesHTML);

          let innerElement = el.querySelector('.option-Tamanho .inner');
          if (innerElement) {
            innerElement.innerHTML = sizesHTML;
          }
        }

        el.querySelectorAll('.size').forEach(sizeSpan => {
          sizeSpan.addEventListener('click', () => {
            if (sizeSpan.dataset.stock > 0) {
              el.querySelectorAll('.size').forEach(span => {
                span.classList.remove('active');
              });
              sizeSpan.classList.add('active');
              if (skuInput) {
                skuInput.value = sizeSpan.dataset.sku;
              }
            }
          });
        });
      });
    });
  },

  async init() {
    await this.setColorsSelection();
  }
}

export default selectionBlockColors;
